<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 text-primary font-weight-bold">Master Benefit Category</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Category</b>
      <br />
      <b-row class="mt-4">
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category English"
            label-for="input-1"
          >
            <input
              id="input-1"
              v-model="item.display"
              v-validate="'required'"
              name="display"
              data-vv-as="Category English"
              class="form-control"
              placeholder="Category English"
            />
            <b-form-invalid-feedback
              id="input-display-feedback"
            >{{ veeErrors.first('display') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category Bahasa"
            label-for="input-1"
          >
            <input
              id="input-1"
              v-model="item.display_id"
              v-validate="'required'"
              name="display_id"
              data-vv-as="Category Bahasa"
              class="form-control"
              placeholder="Category Bahasa"
            />
            <b-form-invalid-feedback
              id="input-display-feedback"
            >{{ veeErrors.first('display_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">Save</b-button>
          <router-link :to="{name: 'BenefitCategory'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Benefit Category!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("display", this.item.display);
              formData.append("display_id", this.item.display_id);
              this.$store
                .dispatch("BenefitCategoryModule/putBenefitCategory", {
                  id: this.$route.params.id,
                  data: formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "BenefitCategory" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    }
  },
  beforeMount() {
    this.$store
        .dispatch("BenefitCategoryModule/getBenefitCategories")
        .then(response => {
          const data = response.data.data.categorys
          if(data) {
            const id = this.$route.params.id;
            this.item = data.find(category => category.id == id);
          } else {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: "Your edit data could not be fetched",
              showConfirmButton: false,
              timer: 1500
            });  
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Your edit data could not be fetched",
            showConfirmButton: false,
            timer: 1500
          });
        });
  },
};
</script>

<style>
</style>
